// extracted by mini-css-extract-plugin
export default {"row":"row__3u34_","chip":"chip__1To8d","promoCodeLabel":"promoCodeLabel__2LifD"};
    if(module.hot) {
      // 1764953349750
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  